import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
export { Head } from "../components/Head"
import Layout from "../components/Layout"
import Hero from "../components/sections/Hero"
import Section from "../components/Sections"
import { useTrackProductView } from "../hooks/useTrackProductView"
import { runFreshDeskLogic, runFreshChatLogic } from "../utils/freshDesk"
import { SensaiPage } from "../gql/generated/graphql"

declare global {
  interface Window {
    FreshworksWidget: any
  }
}

const Page = ({
  pageContext,
  data: { sensaiFreshDeskWidget, sensaiFreshChatWidget, sensaiPage },
}: {
  pageContext: {
    canonicalUrls?: string[]
    slug: string
  }
  data: {
    sensaiPage: SensaiPage
    sensaiFreshDeskWidget: {
      freshDeskTestId?: string
      freshDeskId?: string
      openOnLoad: boolean
      pages: {
        slug?: string
      }[]
    }
    sensaiFreshChatWidget: {
      freshChatToken?: string
      openOnLoad: boolean
      pages: {
        slug?: string
      }[]
    }
  }
}) => {
  const { sections, trackProductView } = sensaiPage

  const {
    freshDeskId,
    freshDeskTestId,
    pages: freshDeskPages,
    openOnLoad: freshDeskOpenOnLoad,
  } = sensaiFreshDeskWidget
  const {
    freshChatToken,
    pages: freshChatPages,
    openOnLoad: freshChatOpenOnLoad,
  } = sensaiFreshChatWidget

  // const [delayedIndex, setDelayed] = useState(0)

  const hero = sections?.find(
    data => data.__typename === "SENSAIComponentZonesHeroZone"
  )

  const hasHero = hero !== null && hero !== undefined

  let triggerProductView: Function
  if (trackProductView) {
    triggerProductView = useTrackProductView(trackProductView)
  }

  useEffect(() => {
    const freshDeskPagesFormatted = freshDeskPages.map(page => page.slug!) || []
    runFreshDeskLogic({
      currentPageSlug: pageContext.slug!,
      freshDeskPages: freshDeskPagesFormatted,
      freshDeskId,
      freshDeskTestId,
      openOnLoad: freshDeskOpenOnLoad,
    })

    const freshChatPagesFormatted = freshChatPages.map(page => page.slug!) || []

    runFreshChatLogic({
      currentPageSlug: pageContext.slug!,
      freshDeskPages: freshChatPagesFormatted,
      freshChatToken,
      openOnLoad: freshChatOpenOnLoad,
    })
    if (trackProductView) {
      setTimeout(() => {
        triggerProductView()
      }, 100)
    }
  }, [])

  return (
    <Layout hasHero={hasHero} showStickFooter={true}>
      {hasHero && <Hero {...hero} />}

      {sections?.map((section, index) => (
        <Section
          key={`${section.__typename}-${section.id}`}
          section={{
            ...section,
          }}
          delayIndex={hasHero ? index : undefined}
        />
      ))}
    </Layout>
  )
}

export default Page

export const pageQuery = graphql`
  query PageById($id: String) {
    sensaiPage(id: { eq: $id }) {
      id
      title
      slug
      trackProductView {
        id
        name
        stripeId
        stripeTestId
      }
      seo {
        metaTitle
        metaDescription
        metaImage {
          url
          imageFile {
            childImageSharp {
              gatsbyImageData(
                placeholder: NONE
                layout: FIXED
                quality: 80
                width: 1200
              )
            }
          }
        }
      }
      sections {
        __typename
        ...PageSectionMembershipZone
        ...PageSectionBannerZone
        ...PageSectionFormZone
        ...PageSectionHeroZone
        ...PageSectionCardZone
        ...PageSectionSimpleContentZone
        ...PageSectionFeatureZone
        ...PageSectionTestimonialsZone
        ...PageSectionTableZone
        ...PageSectionCarouselZone
        ...PageSectionSpecZone
        ...PageSectionStepsZone
        ...PageSectionMiscZones
      }
      parent {
        ... on SENSAIPage {
          title
          slug
        }
      }
      pages {
        ... on SENSAIPage {
          title
          slug
        }
      }
    }
    sensaiFreshDeskWidget {
      freshDeskTestId
      freshDeskId
      openOnLoad
      pages {
        slug
      }
    }
    sensaiFreshChatWidget {
      freshChatToken
      openOnLoad
      pages {
        slug
      }
    }
  }
`
